import styled from 'styled-components'

import { PrimaryButtonFlexable48 } from 'components/Common/MasterComponents'
import breakpoint from 'utils/consts/breakpoints'

export const Container = styled.div`
  max-width: 416px;
  width: 100%;
  z-index: 1;

  @media screen and ${breakpoint.device.mobile} {
    margin: 20px;
  }
`
export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
`
export const Copy = styled(PrimaryButtonFlexable48)`
  margin-right: 8px;
  min-width: 160px;
`
export const Title = styled.div`
  font: var(--typography-14-24-regular);
  color: var(--color-sw-60);
  margin-bottom: 8px;
`
export const Cancel = styled.div`
  min-width: 54px;
  height: 48px;
  margin-right: 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #717284;
  cursor: pointer;
  font: var(--typography-14-15-semibold);
  transition: background-color 0.2s, color 0.2s;

  :hover {
    color: #3b42a5;
  }
`
